import { render, staticRenderFns } from "./RandomUser.vue?vue&type=template&id=6baeef20&"
import script from "./RandomUser.vue?vue&type=script&lang=js&"
export * from "./RandomUser.vue?vue&type=script&lang=js&"
import style0 from "./RandomUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports